export default [
        // events { Events, NewEvent, Edit, EventUsers, AddUserToEvent}
  {
    path: '/company/:id/events',
    name: 'Events',
    props: true,
    component: () => import(/* webpackChunkName: "about" */ '../../../views/events/events.vue'),
    meta: { 
      requiresAuth: true
    }
  },
  {
    path: '/company/:id/new_event',
    name: 'NewEvent',
    props: true,
    component: () => import(/* webpackChunkName: "about" */ '../../../views/events/add.vue'),
    meta: { 
      requiresAuth: true
    }
  },
  {
    path: '/company/event/:id/:id_event/edit',
    name: 'EditEvent',
    props: true,
    component: () => import(/* webpackChunkName: "about" */ '../../../views/events/edit.vue'),
    meta: { 
      requiresAuth: true
    }
  },
  {
    path: '/company/event/:id/:event_id/events_users',
    name: 'EventsUsers',
    props: true,
    component: () => import(/* webpackChunkName: "about" */ '../../../views/events/events_users.vue'),
    meta: { 
      requiresAuth: true
    }
  },
  {
    path: '/company/event/:id/:event_id/add_user_to_event',
    name: 'AddUserToEvent',
    props: true,
    component: () => import(/* webpackChunkName: "about" */ '../../../views/events/add_user_to_event.vue'),
    meta: { 
      requiresAuth: true
    }
  },
  {
    path: '/company/event/:id/:event_id/add_user_to_event',
    name: 'AddUserToEvent',
    props: true,
    component: () => import(/* webpackChunkName: "about" */ '../../../views/events/add_user_to_event.vue'),
    meta: { 
      requiresAuth: true
    }
  },
  {
    path: '/company/event/marking/:id/:event_id',
    name: 'Marking',
    props: true,
    component: () => import(/* webpackChunkName: "about" */ '../../../views/marking/edit.vue'),
    meta: { 
      requiresAuth: true
    }
  },
]